import { Component, OnInit } from "@angular/core";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-faq",
  templateUrl: "./faq.component.html",
  styleUrls: ["./faq.component.css"],
})
export class FAQComponent implements OnInit {
  config;
  constructor(private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit(): void {}
}
